import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import Checkmark from '../../../../../../Cutesies/Checkmark';
import ClientPortalIcon from '../../../../../../Cutesies/ClientPortalIcon';

const ClientPortalLink: React.FC = () => (
  <li className={'flex no-underline relative font-semibold cursor-pointer'}>
    <a
      onClick={(e) => e.preventDefault()}
      data-intercom-target="client-portal-current-location"
      className={clsx(
        'justify-items-start px-3',
        'flex justify-around',
        'items-center text-xs leading-6 text-gray-900 hover:text-teal-600',
      )}
    >
      <span className={'h-10 m-2'}>
        <ClientPortalIcon />
      </span>
      <span className={'pl-3 text-lg'}>
        <T kind={'AdminStudio'} />
      </span>
      <div className={clsx('pl-16 pr-4')}>
        <Checkmark className="fill-gray-500" />
      </div>
    </a>
  </li>
);

export default observer(ClientPortalLink);
